var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253 213.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#666666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.1,208H17.9A12.5,12.5,0,0,1,5.4,195.5V112.6a12.5,12.5,0,0,1,12.5-12.5H235.1a12.5,12.5,0,0,1,12.5,12.5v82.9A12.57,12.57,0,0,1,235.1,208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.1,213.3H17.9A17.88,17.88,0,0,1,0,195.4V112.5A17.88,17.88,0,0,1,17.9,94.6H235.1A17.88,17.88,0,0,1,253,112.5v82.9A18,18,0,0,1,235.1,213.3ZM17.9,105.5a7.13,7.13,0,0,0-7.1,7.1v82.9a7.13,7.13,0,0,0,7.1,7.1H235.1a7.13,7.13,0,0,0,7.1-7.1V112.6a7.13,7.13,0,0,0-7.1-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.8,135.7A20.66,20.66,0,0,1,87.6,154a21.31,21.31,0,0,1-2.9,10.8,20.61,20.61,0,0,1-7.9,7.6,23.54,23.54,0,0,1-11.2,2.8,22.44,22.44,0,0,1-11.2-2.8,21.11,21.11,0,0,1-7.9-29.1,21.36,21.36,0,0,1,7.9-7.6A23.19,23.19,0,0,1,65.6,133,21.38,21.38,0,0,1,76.8,135.7Zm-17.4,7a12.23,12.23,0,0,0-4.6,4.7,13.47,13.47,0,0,0,0,13.1,12.23,12.23,0,0,0,4.6,4.7,11.56,11.56,0,0,0,6.3,1.8,12.13,12.13,0,0,0,10.7-6.4,13.51,13.51,0,0,0,1.7-6.6,12.85,12.85,0,0,0-1.7-6.5,12,12,0,0,0-4.5-4.7,12.3,12.3,0,0,0-6.2-1.7A11.84,11.84,0,0,0,59.4,142.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.1,137.3c2.8,2.5,4.3,6,4.3,10.5,0,4.8-1.4,8.4-4.3,11.1s-6.9,3.9-12.1,3.9h-8.1v11.7H93.7V133.6H111C116.2,133.6,120.2,134.8,123.1,137.3Zm-6.6,16a6.43,6.43,0,0,0,2.1-5.2,6.09,6.09,0,0,0-2.1-5.1,9.52,9.52,0,0,0-6-1.7h-7.7v13.8h7.7A9,9,0,0,0,116.5,153.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.3,133.6h31.1v7.7H142.5v8.9h19.7v7.7H142.5V167H165v7.7H133.2V133.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.6,133.6h8.8v40.9H201l-19.8-26.3v26.3h-8.8V133.6h8.4L200.7,160V133.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.4,104.2l-97-81.8-97,81.8L23.5,96,124,11.3a5.31,5.31,0,0,1,6.9,0L231.4,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.4,30.8a15.4,15.4,0,1,1,15.4-15.4A15.41,15.41,0,0,1,127.4,30.8Zm0-20.1a4.7,4.7,0,1,0,4.7,4.7A4.83,4.83,0,0,0,127.4,10.7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.b106ef7e50737dcfe4e70af1b6cb9d5c.svg";
export { ForwardRef as ReactComponent };